export enum FactorEnum {
	LONG = 1,
	SHORT = -1,
}
